import { useTranslation } from "react-i18next";
import { ReloadWindow } from "iconoir-react";
import { useAppVersionContext } from "useAppVersionContext";
import { WhereaboutsModal } from "shared/components";

/**
 * New-version prompt: must stack above directory slideouts and other `zIndex="max"` UI.
 * Uses {@link WhereaboutsModal} with `isMaxZIndex` (same layer as listing flyouts).
 */
export const AppVersion = () => {
  const { t } = useTranslation("core", { keyPrefix: "APP_VERSION" });
  const { showDialog, handleDialogResponse } = useAppVersionContext();

  return (
    <WhereaboutsModal
      isOpen={showDialog}
      onClose={() => handleDialogResponse(false)}
      HeaderIcon={ReloadWindow}
      title={t("TITLE")}
      description={t("MESSAGE")}
      cancelButtonCopy={t("CANCEL")}
      cancelButtonProps={{
        type: "button",
        flex: 1,
        onClick: () => handleDialogResponse(false),
      }}
      saveButtonCopy={t("CONFIRM")}
      saveButtonProps={{
        type: "button",
        visual: "primary",
        mode: "dark",
        flex: 1,
        onClick: () => handleDialogResponse(true),
      }}
      isMaxZIndex
      size="sm"
      portal
      compact
    />
  );
};
